// Tiny shared helper: only render external <img> tags when the URL is from
// a trusted CDN we know returns stable cannabis content. Anything else
// (most notably Unsplash, which has rotated to non-cannabis images repeatedly)
// must fall back to a self-hosted SVG placeholder.
const TRUSTED_IMAGE_HOSTS = [
  "images.dutchie.com",
  "images.trulieve.com",
  "www.trulieve.com",
  "trulieve.com",
  "sunnyside.shop",
  "www.sunnyside.shop",
  "cdn.shopify.com",
  // Direct cannabis brand CDNs the operator commonly uploads photos from
  "images.weedmaps.com",
  "imgproxy.weedmaps.com",
  "leafly.com",
  "images.leafly.com",
  "i.imgur.com",
  "imgur.com",
  "linklitepro.com",
  "budlink.linklitepro.com",
  "customer-assets.emergentagent.com",
];

export function isTrustedImageUrl(url) {
  if (!url || typeof url !== "string") return false;
  if (url.startsWith("data:")) return true;
  if (url.startsWith("/uploads/")) return true;
  try {
    const u = new URL(url);
    return TRUSTED_IMAGE_HOSTS.some(
      (h) => u.hostname === h || u.hostname.endsWith("." + h)
    );
  } catch {
    return false;
  }
}
